export default __webpack_public_path__ + "static/media/circles-no-7-remix.ff2fcc35.mid";